<template>
  <footer class="footer px-4 bg py-5" :dir="isHebrew ? 'rtl' : 'ltr'" :lang="isHebrew ? 'he' : 'en'">
    <b-container>
      <!-- visible md and up -->
      <b-row
        align-v="center"
        class="justify-content-lg-between d-none d-md-flex"
      >
        <b-col>
          <div class="copyright text-center text-lg-left">
            <!-- social icons -->
            <a
              v-for="(icon, index) in socialIcons"
              :key="index"
              :href="icon.url"
              class="mr-2"
              target="_blank"
              ><img
                :src="icon.icon"
                :width="icon.width"
                :height="icon.height"
            /></a>
            <!-- back to top button -->
            <a href="" style="margin: 1.5rem 1.5rem 0 1.5rem;">
              <svg
                class="caretup rounded ml-auto mr-auto"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                /></svg
            ></a>
          </div>
        </b-col>
        <b-col cols="8">
          <!-- navigation links -->
          <b-nav align="center" class="nav-footer justify-content-lg-center">
            <b-nav-item
              v-for="(item, index) in menuItems"
              :key="index"
              :to="item.url"
            >
              <small style="color: rgba(255, 255, 255, 0.9)" >
                {{ item.text }}
              </small>
            </b-nav-item>
          </b-nav>
        </b-col>
        <b-col>
          <!-- tripplanner logo -->
          <img 
            width="85"
            height="15"
            src="@/assets/images/icons/Tripplanner.svg" />
        </b-col>
        <b-col cols="12" class="mt-5">
          <!-- copyright -->
          <div class="copyright text-center">
            <span class="footer-copyright" style="color: rgba(255, 255, 255, 0.25)">
              {{ t('copyrightWithYear', { year }) }}
            </span>
          </div>
        </b-col>
      </b-row>
      <!-- visible on mobile screens -->
      <b-row align-v="center" class="d-flex d-md-none text-center">
        <b-col cols="12" class="py-4">
          <!-- back to top button -->
          <a href="#" class="caretup-wrapper">
            <svg
              class="caretup caretup-end rounded"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              /></svg
          ></a>
          <!-- tripplanner logo -->
          <img 
            width="85"
            height="15"
            src="@/assets/images/icons/Tripplanner.svg" />
        </b-col>
        <b-col cols="12" class="py-3">
          <!-- navigation links -->
          <b-nav
            vertical
            align="center"
            class="nav-footer justify-content-lg-center"
          >
            <b-nav-item
              v-for="(item, index) in mobileMenuItems"
              :key="index"
              :to="item.url"
            >
              <small style="color: rgba(255, 255, 255, 0.9)" >
                {{ item.text }}
              </small>
            </b-nav-item>
          </b-nav>
        </b-col>
        <b-col cols="12" class="py-3">
          <!-- social icons -->
          <a
            v-for="(icon, index) in socialIcons"
            :key="index"
            :href="icon.url"
            class="mx-4"
            ><img
              :width="icon.width"
              :height="icon.height"
              :src="icon.icon"
          /></a>
        </b-col>
        <b-col class="py-5">
          <!-- copyright -->
          <div class="copyright text-center">
            <span class="footer-copyright" style="color: rgba(255, 255, 255, 0.25)">
              {{ t('copyrightWithYear', { year }) }}
            </span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
<script>
import { translationMixin } from "@/mixins/translationMixin";

export default {
  mixins: [translationMixin],
  data() {
    return {
      year: new Date().getFullYear(),
      socialIcons: [
        {
          width: "24px",
          height: "26px",
          icon: "https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FFacebook_Logo_Primary.png?alt=media&token=2731adce-75a0-493d-ac5d-94a2913b2aa4",
          url: "https://www.facebook.com/tripplanner.co.il",
        },
      ],
    };
  },
  computed: {
    menuItems() {
      return [
        { text: this.t('contact'), url: '/about' },
        { text: this.t('termsOfUse'), url: '/terms_of_use' },
        { text: this.t('privacyPolicy'), url: '/privacy_policy' },
        { text: this.t('searchTrips'), url: '/search_ride' },
        { text: this.t('about'), url: '/about' },
        { text: this.t('home'), url: '/' },
      ];
    },
    mobileMenuItems() {
      return [
        { text: this.t('contact'), url: '/about' },
        { text: this.t('termsOfUse'), url: '/terms_of_use' },
        { text: this.t('privacyPolicy'), url: '/privacy_policy' },
        { text: this.t('searchTrips'), url: '/search_ride' },
        { text: this.t('about'), url: '/about' },
        { text: this.t('home'), url: '/' },
      ];
    },
  },
};
</script>
<style>
.bg {
  background-color: #061c18;
}
.caretup {
  font-size: 64px;
  font-weight: 100;
  line-height: 54px;
  height: 24px;
  width: 24px;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.5);
  color: #2a2a2a;
}
.caretup-wrapper {
  position: relative;
  display: block;
}
.caretup-end {
  position: absolute;
  inset-inline-end: 1em;
}

.footer-copyright {
  font-size: 1.4rem;
}
</style>
